/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';

import { CloseMobile } from '@/icons/index';
import { Button } from '@/ui/index';

import styles from './FaceRecognationInfo.module.scss';

const RecognationInfoModal = ({
  active = false,
  setActive = () => null,
  handleNext,
  className,
  classNameInner,
  isEsim = true,
}) => {
  const { t } = useTranslation();

  const closeModal = (event) => {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', closeModal);

    return () => {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);

  return (
    <div
      className={classNames([
        styles.wrap,
        { [styles.open]: active },
        className,
      ])}
      itemScope
      itemType='https://schema.org/Property'
    >
      <div className={classNames([styles.faceInfoInner, classNameInner])}>
        <div className={styles.faceInfoContent}>
          <div className={styles.close} onClick={() => setActive(false)}>
            <CloseMobile />
          </div>
          <div>
            <h5 className={styles.title}>{t('esim:recognitionInfo.title')}</h5>

            <div
              className={styles.legal_text_box}
              dangerouslySetInnerHTML={{
                __html: t('esim:recognitionInfo.rule'),
              }}
            ></div>
            <p className={styles.description}>
              <span className={styles.text_red}>
                {t('esim:recognitionInfo.first')}
              </span>
              {t('esim:recognitionInfo.second')}
            </p>
            <ul className={styles.list}>
              <li>{t('esim:recognitionInfo.rules.first')}</li>
              <li>{t('esim:recognitionInfo.rules.second')}</li>
              <li>{t('esim:recognitionInfo.rules.third')}</li>
            </ul>
          </div>
          <div className={styles.btn_groups}>
            {isEsim ? (
              <Link
                href={'/contact-us'}
                onClick={() => {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: 'activatestore',
                  });
                }}
                target='_blank'
                rel='noreferrer'
              >
                <a
                  target='_blank'
                  className={styles.actiivate_store_btn}
                  title={t('esim:recognitionInfo.activation')}
                  aria-label={t('esim:recognitionInfo.activation')}
                >
                  {t('esim:recognitionInfo.activation')}
                </a>
              </Link>
            ) : (
              <Button variant='normal'>
                {' '}
                {t('esim:recognitionInfo.startFace')}
              </Button>
            )}

            <Button
              onClick={isEsim ? handleNext : () => setActive(false)}
              variant={isEsim ? 'normal' : 'transparent'}
              className={styles.btn}
            >
              {isEsim ? t('esim:recognitionInfo.startFace') : 'Cancel'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecognationInfoModal;
